import React from 'react';
import {AudioFile} from "types/MediaFile";
import AudioArticle from "pages/Exhibit/Preview/AudioArticle";
import {Disclosure} from "@headlessui/react";

type Props = {
    files: Array<AudioFile>
    previewCount: number
}

function AudioList({files, previewCount}: Props) {
    const previewFiles = files.slice(0, previewCount)
    const remainingFiles = files.slice(previewCount)

    return (
        <>
            <ul className="text-base divide-y divide-gray-200">
                {previewFiles.map(file => (<AudioArticle file={file} key={file.id}/>))}
            </ul>

            {!!remainingFiles.length &&
                <Disclosure>
                    {({open}) => (
                        <>
                            {!open &&
                                <Disclosure.Button className="mt-7 text-brand font-medium">
                                    <span className="underline">View more</span> &gt;
                                </Disclosure.Button>
                            }
                            <Disclosure.Panel>
                                <ul className="mt-8 text-gray-600">
                                    {remainingFiles.map(file => (<AudioArticle file={file} key={file.id}/>))}
                                </ul>
                            </Disclosure.Panel>
                        </>
                    )}
                </Disclosure>
            }
        </>
    );
}

AudioList.defaultProps = {
    previewCount: 4
}

export default AudioList;